import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import IconDelete from "@material-ui/icons/Delete";
import { DropzoneArea } from "material-ui-dropzone";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  list: {
    paddingTop: "0px",
    paddingBottom: "0px",
  },
  listItem: {
    paddingTop: "12px",
    paddingBottom: "12px",
    border: "1px solid #c4c4c4",
    borderRadius: "4px",
  },
}));

function FileSelector(props) {
  const classes = useStyles();

  return (
    <>
      {props.file ? (
        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <ListItemIcon>
              <AttachFileIcon />
            </ListItemIcon>
            <ListItemText
              primary={props.file.name}
              secondary={props.file.file}
            />
            <ListItemSecondaryAction>
              <IconButton onClick={() => props.onChange(null)} edge="end">
                <IconDelete />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      ) : (
        <DropzoneArea
          dropzoneText={props.dropzoneText}
          acceptedFiles={props.accept}
          onChange={(files) => props.onChange(files[0])}
          showPreviews={false}
          showPreviewsInDropzone={false}
        />
      )}
    </>
  );
}

FileSelector.propTypes = {
  file: PropTypes.object,
  dropzoneText: PropTypes.string,
  accept: PropTypes.string,
  onChange: PropTypes.func,
};

FileSelector.defaultProps = {
  file: null,
  dropzoneText: "Arrastar e soltar o arquivo aqui ou clicar",
  accept: "",
  onChange: () => {},
};

export default FileSelector;
